import { FormField, FormSelect } from "web-design-system";
import {
  OCCUPATION,
  INCOME_RANGE,
  SOURCE_OF_WEALTH,
  PEP_STATUS,
} from "creso-core/constants";
import { getFieldLabel } from "creso-core/utils";
import { Section } from "./section";
import { useAccountForm } from "./context";

export function OtherInformationSection() {
  const { form, isEditing } = useAccountForm();

  const dirtyFields = Object.entries(form.formState.dirtyFields.other || {})
    .filter(([, v]) => v)
    .map(([k]) => getFieldLabel(k));

  return (
    <Section title="Other information" dirtyFields={dirtyFields}>
      <div className="grid gap-6 grid-cols-4">
        <FormField
          className="col-span-4 sm:col-span-4 md:col-span-2 lg:col-span-1"
          name="other.occupation"
          render={({ field }) => (
            <FormSelect
              label="Occupation"
              options={OCCUPATION}
              disabled={!isEditing}
              {...field}
            />
          )}
        />
        <FormField
          className="col-span-4 sm:col-span-4 md:col-span-2 lg:col-span-1"
          name="other.income_slab"
          render={({ field }) => (
            <FormSelect
              label="Income range"
              options={INCOME_RANGE}
              disabled={!isEditing}
              {...field}
            />
          )}
        />
        <FormField
          className="col-span-4 sm:col-span-4 md:col-span-2 lg:col-span-1"
          name="other.source_of_wealth"
          render={({ field }) => (
            <FormSelect
              label="Source"
              options={SOURCE_OF_WEALTH}
              disabled={!isEditing}
              {...field}
            />
          )}
        />
        <FormField
          className="col-span-4 sm:col-span-4 md:col-span-2 lg:col-span-1"
          name="other.pep_details"
          render={({ field }) => (
            <FormSelect
              label="Political exposure"
              options={PEP_STATUS}
              disabled={!isEditing}
              {...field}
            />
          )}
        />
      </div>
    </Section>
  );
}
